import { useTranslation } from 'react-i18next';
import logo from '../image/logo.png';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { id: 'products', labelKey: 'nav_products' },
    { id: 'design', labelKey: 'nav_design' },
    { id: 'partners', labelKey: 'nav_partners' },
    { id: 'contact', labelKey: 'nav_contact' },
  ];

  const followLinks = [
    { key: 'contact_wx_label' },
    { key: 'contact_xhs_label' },
    { key: 'contact_dy_label' },
  ];

  return (
    <footer className="bg-gradient-to-br from-[#2a1f14] to-[#3d2c1a] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 sm:gap-12 mb-12 sm:mb-16">
          {/* 品牌介绍 */}
          <div className="col-span-2 sm:col-span-1 flex flex-col items-center text-center">
            {/* 品牌商标区域 */}
            <div className="flex items-center gap-3 mb-5">
              <img
                src={logo}
                alt="Logo"
                className="h-10 w-auto shrink-0"
              />
              <div className="flex flex-col justify-center">
                <span
                  className="text-[15px] font-semibold tracking-[0.22em] uppercase text-[#f0d9b5]"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  Cyan Charm
                </span>
                <div className="flex items-center gap-1.5 mt-[2px]">
                  <div className="h-px flex-1 bg-[#c9a96e]/70"></div>
                  <span
                    className="text-[9px] tracking-[0.35em] text-[#c9a96e]"
                    style={{ fontFamily: "'Noto Serif SC', serif" }}
                  >
                    青韵千艺
                  </span>
                  <div className="h-px flex-1 bg-[#c9a96e]/70"></div>
                </div>
              </div>
            </div>
            <p className="text-[#c9a96e]/80 text-sm leading-relaxed whitespace-pre-line">
              {t('footer_brand_desc')}
            </p>
          </div>

          {/* 快速链接 */}
          <div className="flex flex-col items-center text-center">
            <h4 className="text-xs sm:text-sm font-semibold text-[#c9a96e] uppercase mb-3 sm:mb-4 whitespace-nowrap">
              {t('footer_links_title')}
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-[#e8d5b8]/70 hover:text-[#c9a96e] transition-colors text-xs sm:text-sm cursor-pointer whitespace-nowrap"
                  >
                    {t(link.labelKey)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* 关注我们 */}
          <div className="flex flex-col items-center text-center">
            <h4 className="text-xs sm:text-sm font-semibold text-[#c9a96e] uppercase mb-3 sm:mb-4 whitespace-nowrap">
              {t('footer_follow_title')}
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              {followLinks.map((item) => (
                <li key={item.key}>
                  <a href="#" className="text-[#e8d5b8]/70 hover:text-[#c9a96e] transition-colors text-xs sm:text-sm cursor-pointer whitespace-nowrap">
                    {t(item.key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* 联系信息 */}
        <div className="border-t border-[#c9a96e]/20 pt-8 sm:pt-10 mb-8 sm:mb-10">
          <div className="flex flex-col items-center gap-6 sm:flex-row sm:justify-center sm:items-center sm:gap-12">
              {/* 地址 */}
              <div className="flex items-center gap-3 w-64">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#c9a96e]/15 shrink-0">
                  <i className="ri-map-pin-2-line text-[#c9a96e] text-sm"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-[#c9a96e]/60 text-xs uppercase tracking-widest mb-0.5">{t('contact_address_label')}</p>
                  <p className="text-[#f0d9b5] text-sm font-medium">{t('contact_address_value')}</p>
                </div>
              </div>
              {/* 邮箱 */}
              <div className="flex items-center gap-3 w-64">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#c9a96e]/15 shrink-0">
                  <i className="ri-mail-send-line text-[#c9a96e] text-sm"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-[#c9a96e]/60 text-xs uppercase tracking-widest mb-0.5">{t('contact_email_label')}</p>
                  <a href="mailto:71457279@qq.com" className="text-[#f0d9b5] text-sm font-medium hover:text-[#c9a96e] transition-colors cursor-pointer">
                    71457279@qq.com
                  </a>
                </div>
              </div>
              {/* 电话 */}
              <div className="flex items-center gap-3 w-64">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#c9a96e]/15 shrink-0">
                  <i className="ri-phone-line text-[#c9a96e] text-sm"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-[#c9a96e]/60 text-xs uppercase tracking-widest mb-0.5">{t('contact_phone_label')}</p>
                  <a href="tel:+8613166243999" className="text-[#f0d9b5] text-sm font-medium hover:text-[#c9a96e] transition-colors cursor-pointer">
                    +86 131-6624-3999
                  </a>
                </div>
              </div>
          </div>
        </div>

        {/* 底部大字 */}
        <div className="border-t border-[#c9a96e]/20 pt-8 sm:pt-12">
          <div className="text-center overflow-hidden">
            <h2 className="text-5xl sm:text-7xl lg:text-9xl font-bold tracking-tight bg-gradient-to-r from-[#b8864e] via-[#f0d9b5] to-[#c9a96e] bg-clip-text text-transparent drop-shadow-lg">
              CYAN CHARM
            </h2>
          </div>
        </div>

        {/* 版权信息 */}
        <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-[#c9a96e]/20 text-center">
          <p className="text-xs sm:text-sm font-medium text-[#f0d9b5]">
            Copyright © 2020 - 2026 CyanCharm. All Rights Reserved.{' '}
            <span className="text-[#c9a96e] font-semibold">青韵千艺公司</span>{' '}
            <span className="text-[#f0d9b5]">版权所有</span>
          </p>
          <p className="text-xs text-[#c9a96e]/60 mt-2">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-1 px-3 py-1 rounded-full border border-[#c9a96e]/40 hover:border-[#c9a96e] hover:text-[#c9a96e] hover:bg-[#c9a96e]/10 transition-all duration-200 cursor-pointer"
            >
              粤ICP备2026015265号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}